import type { Command } from './types'

export const preventDefault: Command = (state, dispatch) => true

export type { Command }
export { INDENT_DIRECTION } from './constants'
export {
  breakOutOfList,
  joinListsByDeletion,
  joinListsFromFirstListItem,
  mergeBackwardsIntoListItem,
  sortVoteList,
  splitListItemOnGapCursor,
  splitVoteListItem,
  turnIntoList,
} from './lists'
export { breakOutOfInlineCode } from './breakOutOfInlineCode'
export { changeIndentation } from './changeIndentation'
export { deleteEmptyNode } from './deleteEmptyNode'
export { deleteEmptyToggle } from './deleteEmptyToggle'
export { deleteFirstCodeCharacter } from './deleteFirstCodeCharacter'
export { deleteZeroWidthSpaceWithoutInlineCode } from './deleteZeroWidthSpaceWithoutInlineCode'
export { splitToggleListItem } from './splitToggleListItem'
export { preventZeroWidthSpaceDelete } from './preventZeroWidthSpaceDelete'
export { preventToggleBlockSelectBackward } from './preventToggleBlockSelectBackward'
export { unindentFromStart } from './unindentFromStart'
